import { create } from "zustand";
import { withDevtools } from "./devtools";
import { UserModel } from "../../domain/models/User";
type UserStore = {
  currentUser: UserModel | null;
  setCurrentUser: (user: UserModel | null) => void;
};
export const useUserStore = create<UserStore>()(withDevtools((set: (partial: Partial<UserStore>) => void) => ({
  currentUser: null,
  setCurrentUser: (user: UserModel | null) => set({
    currentUser: user
  })
}), {
  name: "userStore"
}));
export const useCurrentUser = () => {
  return useUserStore(_temp);
};
function _temp(state) {
  return state.currentUser;
}